import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  MobileStepper,
  IconButton,
} from '@mui/material';
import { Favorite, PlaylistAdd, PersonAddAlt } from '@mui/icons-material';
import defaultArt from '../assets/images/dj_kip_art.png';
import { useApi } from '../context/ApiProvider';
import { useUser } from '../context/UserProvider';

const onboardingScreens = [
  {
    headline: 'Welcome to KIP',
    image: (
      <img
        src={defaultArt}
        alt="KIP Art"
        style={{ width: 120, height: 120, borderRadius: 16 }}
      />
    ),
    body: `KIP supports electronic producers, DJs, labels and venues around the world and let's you hear the newest music in human curated sets.`,
  },
  {
    headline: 'Queue it up',
    image: <PlaylistAdd sx={{ fontSize: 80, color: 'primary.main' }} />,
    body: 'Add sets to your queue and listen across devices, picking up where you left off.',
  },
  {
    headline: 'Heart to Save Tracks',
    image: <Favorite sx={{ fontSize: 80, color: 'primary.main' }} />,
    body: 'Click the heart icon in the player as many times as you like - tracks & IDs will automatically be saved to your library.',
  },
  {
    headline: 'Follow Artists, Labels & More',
    image: <PersonAddAlt sx={{ fontSize: 80, color: 'primary.main' }} />,
    body: `KIP let's you follow producers, DJs, festivals, everyone who makes the electronic music scene possible.`,
  },
];

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: { xs: 3, sm: 5 },
  width: { xs: '90vw', sm: 400 },
  maxWidth: 420,
  outline: 'none',
  textAlign: 'center',
};

const OnboardingModal = ({ open, onClose }) => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const total = onboardingScreens.length;
  const api = useApi();
  const { user, setUser } = useUser();

  const finishOnboarding = async () => {
    if (loading) return;
    setLoading(true);
    const response = await api.post('/me/onboarding', {});
    if (response.ok) {
      // Update user context with completed_onboarding true
      setUser({ ...user, completed_onboarding: true });
    }
    setLoading(false);
    onClose();
  };

  const handleNext = () => {
    if (step < total - 1) setStep(step + 1);
    else finishOnboarding();
  };
  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };
  const handleClose = () => {
    finishOnboarding();
  };

  const { headline, image, body } = onboardingScreens[step];

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="onboarding-modal">
      <Box sx={style}>
        <Typography variant="h5" fontWeight="bold" mb={2} color="primary">
          {headline}
        </Typography>
        <Box mb={2} display="flex" justifyContent="center" alignItems="center">
          {image}
        </Box>
        <Typography mb={3} color="text.secondary">
          {body}
        </Typography>
        {/* Custom stepper controls for better spacing */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          mt={2}
        >
          <Button
            size="small"
            onClick={handleBack}
            disabled={step === 0 || loading}
            color="primary"
            sx={{ minWidth: 64 }}
          >
            Back
          </Button>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mx: 2, minWidth: 48, textAlign: 'center' }}
          >
            {step + 1} / {total}
          </Typography>
          <Button
            size="small"
            onClick={handleNext}
            variant="contained"
            color="primary"
            sx={{ minWidth: 64 }}
            disabled={loading}
          >
            {step === total - 1
              ? loading
                ? 'Finishing...'
                : 'Finish'
              : 'Next'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default OnboardingModal;
